import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardHeader,
  CardDescription,
} from "@/components/ui/card";
import { useAuth } from "@/auth/AuthProvider";
import { trackEvent, AnalyticsEvent } from "@/analytics";

export function LoginPage() {
  const { status, identity, signIn } = useAuth();
  useEffect(() => {
    // no-op
  }, []);
  if (status === "signed_in" && identity)
    return <Navigate to="/overview" replace />;
  return (
    <main className="flex h-screen items-center justify-center bg-muted/40 p-6">
      <Card className="w-full max-w-sm" data-testid="login-card">
        <CardHeader>
          <img
            src="/respai-glyph.png"
            alt="RespAI"
            className="mb-3 h-12 w-12"
          />
          <h1 className="font-heading text-2xl font-semibold leading-none tracking-tight">
            RespAI Admin
          </h1>
          <CardDescription>
            Sign in with your department account.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <Button
            className="w-full"
            onClick={() => {
              trackEvent(AnalyticsEvent.LoginStarted);
              void signIn();
            }}
          >
            Sign in with Cognito
          </Button>
          <p className="text-xs text-muted-foreground">
            Firefighters and incident commanders use the iOS apps. This
            dashboard is for department administrators.
          </p>
        </CardContent>
      </Card>
    </main>
  );
}
